import axios from "axios";
import { Token } from "../utils/localStorage.util";
import config from "../config.js";

const apiEsocial = axios.create({
  baseURL: config.REACT_APP_HOST_API_ESOCIAL,
  // baseURL: "http://localhost:3336"
});

apiEsocial.interceptors.request.use(
  async (config) => {
    const token = Token.getToken();
    if (token) {
      config.headers.Authorization = token;
    }

    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

apiEsocial.interceptors.response.use(
  (response) => {
    return response.data;
  },

  async function (error) {
    if (error?.code === "ERR_NETWORK") {
      console.error("Erro de conexão (ERR_NETWORK):", error);
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default apiEsocial;

export function obterBasesCalculo(idEmpresa) {
  return apiEsocial.get(`/bases-calculo/${idEmpresa}`);
}

export function obterBasesCalculoPorCampoDeBusca(idEmpresa, textoBusca) {
  return apiEsocial.get(
    `/bases-calculo/${idEmpresa}/buscar-por-campos?textoDeBusca=${encodeURIComponent(
      textoBusca
    )}`
  );
}

export function cadastrarBasesCalculo(idEmpresa, baseCalculo) {
  return apiEsocial.post(`/bases-calculo/${idEmpresa}`, baseCalculo);
}

export function atualizarBasesCalculo(idEmpresa, idBase, baseCalculo) {
  return apiEsocial.put(`/bases-calculo/${idEmpresa}/${idBase}`, baseCalculo);
}

export function excluirBasesCalculo(idEmpresa, idBase) {
  return apiEsocial.delete(`/bases-calculo/${idEmpresa}/${idBase}`);
}

export function obterImpostos(idEmpresa) {
  return apiEsocial.get(`/impostos/${idEmpresa}`);
}

export function obterImpostosPorCampoDeBusca(idEmpresa, textoBusca) {
  return apiEsocial.get(
    `/impostos/${idEmpresa}/buscar-por-campos?textoDeBusca=${encodeURIComponent(
      textoBusca
    )}`
  );
}

export function cadastrarImpostos(idEmpresa, impostos) {
  return apiEsocial.post(`/impostos/${idEmpresa}`, impostos);
}

export function atualizarImpostos(idEmpresa, idImposto, impostos) {
  return apiEsocial.put(`/impostos/${idEmpresa}/${idImposto}`, impostos);
}

export function excluirImpostos(idEmpresa, idImposto) {
  return apiEsocial.delete(`/impostos/${idEmpresa}/${idImposto}`);
}

export function obterVerbasAjustadas(idEmpresa) {
  return apiEsocial.get(`/verbas/${idEmpresa}/ajustes`);
}

export function criarAjusteManualVerba(idEmpresa, dados) {
  return apiEsocial.post(`/verbas/${idEmpresa}/ajuste`, dados);
}

export function obterVerbasAjustadasPorCampoDeBusca(
  idEmpresa,
  textoBusca,
  tipoPesquisa
) {
  return apiEsocial.get(
    `/verbas/${idEmpresa}/ajustes/buscar-por-campos?textoDeBusca=${encodeURIComponent(
      textoBusca
    )}&tipoPesquisa=${tipoPesquisa}`
  );
}

export function obterVerbas(idEmpresa) {
  return apiEsocial.get(`verbas/${idEmpresa}`);
}

export function obterFolhas(idEmpresa) {
  return apiEsocial.get(`folha/${idEmpresa}`);
}

export function buscaVerbasComValoresPorTexto(idEmpresa, texto) {
  return apiEsocial.get(
    `/folha/${idEmpresa}/buscar-folha?textoDeBusca=${texto}`
  );
}

export function buscarVerbasEsocialPorTexto(idEmpresa, texto) {
  return apiEsocial.get(
    `/verbas/${idEmpresa}/buscar-por-campos?textoDeBusca=${texto}`
  );
}

export function resumoGeral(body) {
  return apiEsocial.post(`/folha/resumo-geral`, body);
}

export function buscarTaxaSelic() {
  return apiEsocial.get(`/bases-calculo/taxa-selic`);
}
